import Constant from '@/const';
const axios = require('axios');

const getCategoryMarginList = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/setting/drug-margin/drug'),
      { params },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getCategoryMarginList;
